import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

export const saveCoupon = (body, sellerId, token) =>
  request(`${apiUrl}/sellers/${sellerId}/coupons`, token, {
    body: JSON.stringify(body),
    method: 'POST',
  });
